import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
import { Countdown } from './ui/Countdown';
export function UrgencySection() {
  return <section className="bg-navy text-center text-pearl" aria-label="Limited time offer" data-id="element-215" data-mp="2sk46nkhn1yb1">
      <div className="h-1 w-full bg-gold" aria-hidden="true" data-id="element-216" data-mp="36ar315zxfc3y" />
      <div className="mx-auto max-w-3xl px-4 py-12" data-id="element-217" data-mp="31ipjcz0fij3w">
        <p className="inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-wider text-gold" data-id="element-218" data-mp="31hy08no0qdui">
          <AlertTriangleIcon className="h-4 w-4" aria-hidden="true" data-id="element-219" data-mp="3ga84fb85b3u4" /> Launch pricing ends in:
        </p>
        <Countdown className="mt-5" data-id="element-220" data-mp="3bbeqxisuzcty" />
        <p className="mt-7 font-medium text-pearl/80" data-id="element-221" data-mp="3p93fp1q1r44a">After that the price increases and never drops again.</p>
      </div>
      <div className="h-1 w-full bg-gold" aria-hidden="true" data-id="element-222" data-mp="3l8jglslwxqfi" />
    </section>;
}